<template>
    <div>
        <div
        v-for="camplist in campaign_list"
        :key="camplist.id"
        class="log-detail camaign-log-content">

            <div class="top-bar">
                <div class="top-bar-left">
                    <h2>{{camplist.campaign_name}}</h2>
                </div>

                <div class="top-bar-right">
                    <!-- <div class="people-reached">
                        <p><img src="~styles/img/people.png" alt="">{{camplist.people_reached}}</p>
                    </div> -->

                    <!-- <div class="offer">
                        <p><img src="~styles/img/offer.png" alt="">{{camplist.offer_percent}}</p>
                    </div> -->
                </div>
            </div>

            <div class="log-detail-box">
                <div class="status">
                    <p><i class="glyphicon glyphicon-record"></i> 
                    <span v-if="camplist.status == '0'">Running</span>
                    <span v-if="camplist.status == '1'">End</span>
                    <span v-if="camplist.status == '2'">Stopped</span>
                    </p>
                </div>

                <div class="message">
                    <p>{{camplist.sms}}</p>
                </div>

                <div class="timeline">
                    <p>{{camplist.start_date}}, {{camplist.dispatch_time}} to {{camplist.end_date}}</p>
                </div>
            </div>
            
        </div>

        <!-- <div class="load-more">
            <button type="button" class="btn btn-loadmore" @click="openAllCampaign = true">Load more</button>
        </div> -->
    </div>
</template>


<script>
import axios from 'axios';
import {getcampaigns, getHeader} from './../../../config';

export default {
    data() {
        return {
            campaign_list: [{
                campaign_name: "",
                id: "",
                sms: "",
                dispatch_time: "",
                dispatch_day: "",
                from_number: "",
                start_date: "",
                end_date: "",
                to_all: "",
                to_group: "",
                status: "",
                campaign_type: ""
            }]
        }
    },
    mounted() {
        axios
        .get(getcampaigns, {headers: getHeader()})
        .then(Response => {
            // console.log(Response)
            this.campaign_list = Response.data.data
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/parts/campaignlog.vue